import React from "react";
import { Text } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";

function PrivacyPolicyLocation() {
  const { pathname } = useLocation();
  const appName = decodeURIComponent(pathname.substring(16)); // URL kodlamasını çöz

  return (
    <div className="container">
      <div className="header">
        <div className="header__right">
          <a href="/">
            <Text fontWeight="black" color="#fff" fontSize={20}>
              Muhammed Deniz
            </Text>
          </a>
        </div>

        <div className="header__left">
          <Link to="/home">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Home
            </Text>
          </Link>

          <Link to="/privacypolicy">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Privacy Policy
            </Text>
          </Link>
        </div>
      </div>

      <div style={{ margin: 60, marginLeft: "10%", marginRight: "15%" }}>
        <Text fontSize="xl" mb={5} fontWeight="black" color="#fff">
          Privacy Policy
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Your privacy is important to us. It is Muhammed Deniz's policy to
          respect your privacy regarding any information we may collect from you
          through our app, <span style={{ fontWeight: "bold" }}>{appName}</span>
          .
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          We only ask for personal information when we truly need it to provide
          a service to you. We collect it by fair and lawful means, with your
          knowledge and consent. We also let you know why we're collecting it
          and how it will be used.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          We only retain collected information for as long as necessary to
          provide you with your requested service. What data we store, we'll
          protect within commercially acceptable means to prevent loss and
          theft, as well as unauthorised access, disclosure, copying, use or
          modification.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          We don't share any personally identifying information publicly or with
          third-parties, except when required to by law.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Our app may link to external sites that are not operated by us. Please
          be aware that we have no control over the content and practices of
          these sites, and cannot accept responsibility or liability for their
          respective privacy policies.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Your continued use of our app will be regarded as acceptance of our
          practices around privacy and personal information. If you have any
          questions about how we handle user data and personal information, feel
          free to contact us.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          This policy is effective as of 4 may 2076.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          1. Terms
        </Text>

        <Text fontSize="m" color="#fff" mb={5}>
          By accessing our app,{" "}
          <span style={{ fontWeight: "bold" }}>{appName}</span>, you are
          agreeing to be bound by these terms of service, all applicable laws
          and regulations, and agree that you are responsible for compliance
          with any applicable local laws. If you do not agree with any of these
          terms, you are prohibited from using or accessing
          <span style={{ fontWeight: "bold" }}>{appName}</span>. The materials
          contained in <span style={{ fontWeight: "bold" }}>{appName}</span> are
          protected by applicable copyright and trademark law.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          2. Use License
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Permission is granted to temporarily download one copy of{" "}
          <span style={{ fontWeight: "bold" }}>{appName}</span> per device for
          personal, non-commercial transitory viewing only. This is the grant of
          a license, not a transfer of title, and under this license you may
          not:
        </Text>

        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - modify or copy the materials;
        </Text>

        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - use the materials for any commercial purpose, or for any public
          display (commercial or non-commercial)
        </Text>
        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - attempt to decompile or reverse engineer any software contained in
          <span style={{ fontWeight: "bold" }}>{appName}</span>
        </Text>
        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - remove any copyright or other proprietary notations from the
          materials; or
        </Text>
        <Text fontSize="s" color="#fff" mt={5} mb={5}>
          - transfer the materials to another person or "mirror" the materials
          on any other server.
        </Text>

        <Text fontSize="m" color="#fff" mt={10} mb={5}>
          This license shall automatically terminate if you violate any of these
          restrictions and may be terminated by Muhammed Deniz at any time. Upon
          terminating your viewing of these materials or upon the termination of
          this license, you must destroy any downloaded materials in your
          possession whether in electronic or printed format.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          3. Disclaimer
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          The materials within{" "}
          <span style={{ fontWeight: "bold" }}>{appName}</span>
          basis. Muhammed Deniz makes no warranties, expressed or implied, and
          hereby disclaims and negates all other warranties including, without
          limitation, implied warranties or conditions of merchantability,
          fitness for a particular purpose, or non- infringement of intellectual
          property or other violation of rights.
        </Text>
        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Further, Muhammed Deniz does not warrant or make any representations
          concerning the accuracy, likely results, or reliability of the use of
          the materials on its website or otherwise relating to such materials
          or on any sites linked to{" "}
          <span style={{ fontWeight: "bold" }}>{appName}</span>.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          4. Limitations
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          In no event shall Muhammed Deniz or its suppliers be liable for any
          damages (including, without limitation, damages for loss of data or
          profit, or due to business interruption) arising out of the use or
          inability to use <span style={{ fontWeight: "bold" }}>{appName}</span>
          , even if Muhammed Deniz or a Muhammed Deniz authorised representative
          has been notified orally or in writing of the possibility of such
          damage. Because some jurisdictions do not allow limitations on implied
          warranties, or limitations of liability for consequential or
          incidental damages, these limitations may not apply to you.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          5. Accuracy of materials
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          The materials appearing in{" "}
          <span style={{ fontWeight: "bold" }}>{appName}</span>
          could include technical, typographical, or photographic errors.
          Muhammed Deniz does not warrant that any of the materials on{" "}
          <span style={{ fontWeight: "bold" }}>{appName}</span> are accurate,
          complete or current. Muhammed Deniz may make changes to the materials
          contained in
          <span style={{ fontWeight: "bold" }}>{appName}</span> at any time
          without notice. However Muhammed Deniz does not make any commitment to
          update the materials.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          6. Links
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Muhammed Deniz has not reviewed all of the sites linked to its app and
          is not responsible for the contents of any such linked site. The
          inclusion of any link does not imply endorsement by Muhammed Deniz of
          the site. Use of any such linked website is at the user own risk.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          7. Modifications
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          Muhammed Deniz may revise these terms of service for its app at any
          time without notice. By using{" "}
          <span style={{ fontWeight: "bold" }}>{appName}</span> you are agreeing
          to be bound by the then current version of these terms of service.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          8. Governing Law
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          These terms and conditions are governed by and construed in accordance
          with the laws of İstanbul and you irrevocably submit to the exclusive
          jurisdiction of the courts in that State or location.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          <div id="location-data-processing">9. Location Data Processing</div>
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          We provide the following information about the collection, use, and
          sharing of your location data:
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Collection and Purpose of Location Data
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Our app collects precise location data to measure and track your
          field scanning activities.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Location data is only collected when you are actively using the app
          and have granted location permission.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • This data is used to calculate how much area you have covered in
          your agricultural field, define field boundaries, and perform
          efficiency analyses.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Your location data is used to provide you with better field
          management service and generate useful statistics for you.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Data Storage
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Your location data is stored only on your device (local storage) in
          encrypted form and is not sent to our servers.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Your location data is stored on your device only for the duration
          necessary to provide our services.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • When you delete the app or clear your data, this information is
          completely removed.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Sharing with Third Parties
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Your location data is stored only on your device and is not shared
          with any third parties.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Since your data is not sent to our servers or cloud services, it is
          not accessible to third parties.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Your location data is processed only on your device and remains
          under your control.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          Data Security
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • All your location data is encrypted using industry-standard
          protocols.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • We implement appropriate technical measures to protect your location
          data on your device.
        </Text>

        <Text fontSize="l" color="#fff" fontWeight="bold" mt={10} mb={5}>
          User Control and Permissions
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • Your explicit permission is required to collect location data. You
          can change this permission at any time through your device settings.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • If you do not grant location permission, some of our services such
          as field scanning and area calculation features will be limited or
          unavailable.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • You can request the deletion of your location data at any time
          through the app or by sending us an email.
        </Text>

        <Text fontSize="m" color="#fff" mt={5} mb={5}>
          • When you grant access to location, you agree to the processing of
          your data as described in this policy.
        </Text>

        <div>
          <Text
            fontSize="xl"
            color="#fff"
            fontWeight="hairline"
            mt={20}
            mb={0}
            align="right"
          >
            Muhammed Deniz
          </Text>

          <Text
            fontSize="s"
            color="#fff"
            fontWeight="hairline"
            mt={0}
            mb={20}
            align="right"
          >
            <span style={{ fontWeight: "bold" }}>{appName}</span>
          </Text>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyLocation;
